import { FormType } from '../../../form-types';
import { SermorelinFieldAnswers } from '../questions';

const sermorelin: FormType<SermorelinFieldAnswers> = {
  name: 'Metabolic Support Consultation',
  questions: [
    {
      key: 'sermorelin_sexAssignedAtBirth',
      next: {
        condition: { 'sermorelin_sexAssignedAtBirth.female': true },
        key: 'sermorelin_pregnancyStatus',
        els: 'generic_heightWeight2025'
      }
    },
    {
      key: 'sermorelin_pregnancyStatus',
      next: {
        switch: [
          {
            condition: { 'sermorelin_pregnancyStatus.yes': true },
            key: 'sermorelin_ineligible'
          }
        ],
        els: 'sermorelin_pregnancyConsent'
      }
    },
    {
      key: 'sermorelin_pregnancyConsent',
      next: {
        switch: [
          {
            condition: { 'sermorelin_pregnancyConsent.non_consent': true },
            key: 'sermorelin_didNotConsent'
          }
        ],
        els: 'generic_heightWeight2025'
      }
    },
    'generic_heightWeight2025',
    {
      key: 'sermorelin_goals',
      next: {
        condition: { 'sermorelin_goals.other': true },
        key: 'sermorelin_customGoal',
        els: 'sermorelin_cardiovascularHealth'
      }
    },
    'sermorelin_customGoal',
    'sermorelin_cardiovascularHealth',
    'sermorelin_strength',
    'sermorelin_additionalQuestions',
    'sermorelin_complete',
    'sermorelin_ineligible',
    'sermorelin_didNotConsent'
  ]
};

export default sermorelin;
